module.exports = __webpack_public_path__ + "img/hr-ccm-universal-05-shadow-combined.878862c0.png";